// Re-export all generated API types here
export {
  type components as RfpComponents,
  type operations as RfpOperations,
  type paths as RfpPaths,
} from "./generated/group-rfp-types";

export {
  RfpVisionBenefitFrequencyOptionEnum,
  PolicyPeriodEnum as BaseBenefitPlanPolicyPeriod,
  BenefitPlanTypeEnum,
  CoverageTypeEnum,
  FundingTypeEnum,
  OptionNameEnum as PlanOptionNameEnum,
  StateTerritoryCodeEnum,
  RfpDollarBenefitEnum,
  RfpPercentageBenefitTypeEnum,
  RfpDentalServiceCategoryEnum,
  OutOfNetworkReimbursementEnum,
  RfpOrthoAgeLimitTypeEnum as RfpOrthoAgeLimitType,
  RfpInclusionStatusEnum,
  RfpAnnualOpenEnrollmentEnum,
  RfpDeductibleDurationEnum,
  IndividualDeductibleEnum,
  NetworkEnum,
  // Rate-related enums
  RateDesignEnum,
  RateUnitEnum,
  GenderCodeEnum as RateGender,
  RateCoverageIndicatorEnum as RateScheduleRateCoverageIndicator,
  CoverageTierEnum,
  RateGuaranteeTypeEnum,
  // Commission-related enums
  CurrentCommissionTypeEnum,
  CommissionTypeEnum,
  // Cancer-related enums
  RfpVisionCopayRuleTypeEnum as RfpCancerAmountBenefitType,
  RfpCancerHospiceBenefitTypeEnum as RfpCancerHospiceBenefitType,
  RfpCancerScheduleBenefitTypeEnum as RfpCancerScheduleBenefitType,
  CancerInitialDiagnosisWaitingPeriodTypeEnum as BaseCancerBenefitInitialDiagnosisWaitingPeriodType,
  RfpPreExistingConditionTypeEnum as PreExistingConditionTypeEnum,
  // Hospital Indemnity/Vision-related enums
  RfpVisionCopayRuleTypeEnum as RfpVisionCopayRuleType,
  RfpVisionCopayAllowanceRuleTypeEnum as RfpVisionCopayAllowanceRuleType,
  RfpVisionSpecialCopayAllowanceRuleTypeEnum as RfpVisionSpecialCopayAllowanceRuleType,
  RfpFramesDiscountsRuleTypeEnum as RfpFramesDiscountsRuleType,
  RfpVisionBenefitFrequencyOptionEnum as VisionBenefitFrequency,
  EmployerContributionEnum,
  RfpInclusionStatusEnum as PortabilityEnum,
  // Basic Life-related enums
  RfpBasicLifeBenefitAmountTypeEnum as BaseBasicLifeAdndBenefitBenefitAmountType,
  BenefitMaximumTypeEnum as BaseBasicLifeAdndBenefitBenefitMaximumType,
  RfpBasicLifeGuaranteeIssueTypeEnum as BaseBasicLifeAdndBenefitGuaranteeIssueType,
  RfpVisionCopayRuleTypeEnum as RfpBasicLifeAdndBenefitSpouseBenefitType,
  RfpAgeReductionScheduleTypeEnum as RfpAgeReductionScheduleType,
  DefinitionOfEarningsTypeEnum as DefinitionOfEarningsEnum,
  RfpPortabilityTypeEnum,
  RfpPortabilityTypeEnum as RfpPortabilityType,
  // Voluntary Life-related enums
  RfpVoluntaryLifeEmployeeBenefitTypeEnum,
  BenefitMaximumTypeEnum as RfpVoluntaryLifeBenefitMaximumTypeEnum,
  RfpVoluntaryLifeGuaranteeIssueTypeEnum,
  RfpVoluntaryLifeSpouseChildBenefitTypeEnum,
  RfpVoluntaryLifeAmountNotToExceedTypeEnum,
  RfpVoluntaryLifeAdndTiedToLifeTypeEnum as RfpVoluntaryLifeAdndTiedToLifeEnum,
  RfpAgeReductionScheduleTypeEnum as RfpVoluntaryLifeAgeReductionScheduleTypeEnum,
  // STD/LTD-related enums
  StdBenefitAmountTypeEnum as BenefitAmountTypeEnum,
  MaximumAmountTypeEnum,
  DefinitionOfDisabilityTypeEnum as DefinitionOfDisabilityEnum,
  RfpEliminationPeriodTypeEnum as EliminationPeriodTypeEnum,
  BenefitDurationTypeEnum,
  RfpBillableTypeEnum as BillableTypeEnum,
  RfpLtdOwnOccupationPeriodTypeEnum as RfpOwnOccupationPeriodType,
  RfpGainfulEarningsRuleTypeEnum as RfpGainfulEarningsTestType,
  RfpLtdOtherLimitationsEnum as RfpLimitationType,
  RfpRehabTypeEnum as RfpRehabEnum,
  RfpStdBenefitDurationTypeEnum,
  RfpLtdOtherLimitationsEnum,
  // Individual Disability-related enums
  RfpLtdPlanDesignTypeEnum,
  RfpIdiPlanDesignTypeEnum,
  RfpRecoveryBenefitEnum,
  RfpCatastrophicBenefitEnum,
  // Critical Illness-related enums
  CriticalIllnessEmployeeBenefitDescriptionTypeEnum,
  CriticalIllnessEmployeeMaximumTypeEnum,
  RfpCriticalIllnessEmployeeGuaranteeIssueTypeEnum,
  RfpCriticalIllnessSpouseBenefitDescriptionTypeEnum,
  RfpCriticalIllnessSpouseMaximumTypeEnum,
  RfpIllnessTypeEnum,
  RfpMaximumPayoutTypeEnum,
  RfpOccurrenceTypeEnum,
  RfpAgeBasisEnum,
  // Accident-related enums
  RfpAccidentCoverageTypeEnum,
  RfpAccidentSpecificBenefitTypeEnum,
  RfpAccidentBenefitTypeEnum,
  RfpAccidentMaxBenefitTypeEnum,
  // EAP-related enums
  EapObjectTypeEnum as BaseEapBenefitObjectType,
  RfpTiedToAnotherLocEnum,
  // Whole Life-related enums
  WholeLifeCoverageTypeEnum as BaseWholeLifeBenefitCoverageType,
  WholeLifeEmployeeBenefitMaximumTypeEnum as BaseWholeLifeBenefitEmployeeBenefitMaximumType,
  RfpWholeLifeCoverageEffectiveDateEnum as RfpWholeLifeBenefitCoverageEffectiveDate,
  // FML-related enums
  RfpFmlBenefitTypeEnum as RfpFlmBenefitTypeType,
  FmlObjectTypeEnum as BaseFmlBenefitObjectType,
  // Dental enums
  DentalObjectTypeEnum,
  // Vision enums
  RfpVisionCopayFullAllowanceRuleTypeEnum as RfpVisionCopayFullAllowanceRuleType,
  ServiceWaitingPeriodTypeEnum as ServiceWaitingPeriodType,
} from "./generated/group-rfp-types";

// Whole Life custom enums (not from generated types)
export {
  RfpWholeLifeBenefitEmployeeBenefitAmountType,
  RfpWholeLifeBenefitDependentBenefitType,
} from "./whole-life-enums";

// ========================================
// Frontend-only enum values and utilities
// ========================================

/**
 * Frontend-only enum value for benefits where disclosure is not required.
 * Never sent to the backend - benefits with this type are omitted entirely.
 */
export const NotDisclosed = "notDisclosed" as const;

/**
 * Frontend-only enum value for service waiting periods when none are specified.
 * When selected, sends an empty array to the backend.
 */
export const ServiceWaitingPeriodsNone = "None" as const;

/**
 * The v5 "carrier does not offer this benefit" value. Unlike NotDisclosed
 * (a legacy 4.1 sentinel), notOffered is a first-class v5 enum member on the
 * Quote-side benefit enums, so it round-trips to the backend normally.
 */
export const NotOffered = "notOffered" as const;

/**
 * Default disabled values for type/amount benefit pairs.
 * When a benefit type has one of these values, associated amount/duration fields are disabled.
 */
export const DefaultDisabledBenefitValues = [
  "notIncluded",
  "notApplicable",
  NotDisclosed,
  NotOffered,
] as const;

/**
 * Helper to add frontend-only notDisclosed value to an array of values.
 *
 * @param values - Array of values
 * @returns Array with "notDisclosed" appended
 *
 * @example
 * const extendedValues = addNotDisclosed(["value1", "value2"]);
 */
export function addNotDisclosed(values: string[]): string[] {
  return [...values, NotDisclosed];
}

/**
 * Helper to extend an OpenAPI enum with frontend-only notDisclosed value.
 * Automatically calls Object.values() on the enum for convenience.
 *
 * @param enumObject - The OpenAPI enum object (e.g., RfpCancerAmountBenefitType)
 * @returns Array of enum values with "notDisclosed" appended
 *
 * @example
 * // Instead of: Object.values(RfpCancerAmountBenefitType).concat("notDisclosed")
 * typeEnumValues: extendEnumWithNotDisclosed(RfpCancerAmountBenefitType)
 */
export function extendEnumWithNotDisclosed(
  enumObject: Record<string, string>,
): string[] {
  return addNotDisclosed(Object.values(enumObject));
}

/**
 * Helper to add the notOffered value to an array of values.
 *
 * @param values - Array of values
 * @returns Array with "notOffered" appended
 */
export function addNotOffered(values: string[]): string[] {
  return [...values, NotOffered];
}

/**
 * Helper to extend an OpenAPI enum with the notOffered value.
 * Automatically calls Object.values() on the enum for convenience.
 *
 * @param enumObject - The OpenAPI enum object (e.g., RfpCancerAmountBenefitType)
 * @returns Array of enum values with "notOffered" appended
 */
export function extendEnumWithNotOffered(
  enumObject: Record<string, string>,
): string[] {
  return addNotOffered(Object.values(enumObject));
}

/**
 * Helper to add both notDisclosed and notOffered to an array of values.
 *
 * notDisclosed is retained so BTX-sourced (Incumbent/Requested) values still
 * render, while notOffered is the v5 value analysts select going forward.
 */
export function addNotDisclosedAndNotOffered(values: string[]): string[] {
  return addNotOffered(addNotDisclosed(values));
}

/**
 * Helper to extend an OpenAPI enum with both notDisclosed and notOffered.
 * Automatically calls Object.values() on the enum for convenience.
 */
export function extendEnumWithNotDisclosedAndNotOffered(
  enumObject: Record<string, string>,
): string[] {
  return addNotDisclosedAndNotOffered(Object.values(enumObject));
}
